const features = [
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持1080P高清播放，带来细腻逼真的视觉享受，每一帧都清晰动人',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅不卡顿',
    desc: '采用先进加速技术，高清视频秒加载，观影过程中无需等待缓冲',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '片库每日持续更新，最新高清电影、热播剧集第一时间上线',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全免费',
    desc: '无需注册、无需付费，免费畅享海量高清资源，安全无广告干扰',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              蘑菇影院用心打造极致高清观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {features.map((feat, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-accent-200/50 transition-all cursor-pointer group"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                  <i className={`${feat.icon} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}